import axios from 'axios';
export default {
    data(){
        return {
            cid: '',
            accessKey: '',
            hitType: '',
            categoryId: '',
            categoryName: '',
            content: '',
            phoneNo: '',
            email: '',
            images: [],
            imagesData:[],
            alertText: '',
            isSuccess: false,
            disabled: false,
            dateSlots: [],
            popupVisible: false
        }
    },
    mounted() {
        if (this.$route.query) {
            const { botKey,accessKey} = this.$route.query;
            this.cid = this.$route.query.cid ? this.$route.query.cid : '';
            this.accessKey = botKey || accessKey || '';
            this.hitType = this.$route.query.hitType ? this.$route.query.hitType : '';
        }
        if (this.cid == '') {
            // history.go(-1);
        }else{
            this.getCategorys();
        }
    },
    methods: {
        /**
         * 获取问题分类
        */
        async getCategorys(){
            if (this.accessKey == '') {return}
            let res = await this.$http.get(`/feedback/category/${this.accessKey}`);
            if (res.ret == 0) {
                this.dateSlots = [
                    {
                        flex: 1,
                        values: res.data,
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ];
            }
        },
        handleConfirm(){
            let values = this.$refs.picker.getValues();
            this.categoryId = values[0].id;
            this.categoryName = values[0].content;
            this.popupVisible = false;
        },
        /**
         * 当input发生改变时，触发此方法。
         * 遍历input选中的文件，将文件转成base64字符串存入数组。
         * 并将base64转成图片预览
        */
        imageUpload(file){
            let that = this;
            let fileObj = this.$refs['uploadFile'].files[0];
            let typeList = ['image/gif','image/jpeg','image/jpg','image/png'];
            if(fileObj) {
                if(fileObj.size > 10 * 1024 * 1024){
                    this.alertText = '上传的文件不能大于10M'
                    this.cancelTimer();
                    return;
                }
                if (typeList.indexOf(fileObj.type) == -1) {
                    this.alertText = '上传的文件类型不正确'
                    this.cancelTimer();
                    return;
                }
                var fileRader = new FileReader();
                this.imagesData.push(fileObj);
                fileRader.readAsDataURL(fileObj);
                fileRader.onload = function (event) {
                    that.images.push(event.target.result);
                }
            }
        },
        /**
         * 删除图片
        */
        delImg(index){
            this.images.splice(index, 1);
            this.imagesData.splice(index, 1);
        },
        /**
         * 提交反馈
        */
        async save(){
            if (this.dateSlots.length>0 && this.dateSlots[0].values.length > 0 && this.categoryId == '') {
                this.alertText = '请选择问题分类';
                this.cancelTimer();
                return;
            }
            if (this.content == '') {
                this.alertText = '请填写您需要反馈的问题';
                this.cancelTimer();
                return;
            }
            if (this.phoneNo == '') {
                this.alertText = '请填写您的手机号';
                this.cancelTimer();
                return;
            }else{
                let uPattern = /^[1][3,4,5,7,8,9][0-9]{9}$/;
                if (!uPattern.test(this.phoneNo)) {
                    this.alertText = '手机号格式不正确';
                    this.cancelTimer();
                    return;
                }
            }
            if (this.email != '') {
                let uPattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                if (!uPattern.test(this.email)) {
                    this.alertText = '邮箱格式不正确';
                    this.cancelTimer();
                    return;
                }
            }
            if (this.disabled) {return;}
            let that = this;
            let data = new FormData();
            data.append('cid', this.cid);
            data.append('description', this.content);
            data.append('mobile', this.phoneNo);
            data.append('email', this.email);
            data.append('hitType', this.hitType);
            data.append('categoryId', this.categoryId);
            for(var i = 0; i < this.imagesData.length; i++){
                data.append('attachments', this.imagesData[i]);
            }
            this.disabled = true;
            await axios.post(window.api + '/connector/api/feedback', data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                if (response.status == 200) {
                    if (response.data.ret == 0) {
                        that.content = '';
                        that.phoneNo = '';
                        that.email = '';
                        that.images = [];
                        that.imagesData = [];
                        that.isSuccess = true;
                        that.disabled = false;
                        setTimeout(function(){
                            that.isSuccess = false;
                            history.go(-1);
                        }, 3000);
                        return;
                    }else{
                        that.disabled = false;
                        that.alertText = response.data.msg;
                        that.cancelTimer();
                    }
                } else {
                    that.disabled = false;
                    that.alertText = '服务异常，请稍后再试';
                    that.cancelTimer(); 
                }
            }).catch(function (error) {
                that.disabled = false;
                that.alertText = '服务异常，请稍后再试';
                that.cancelTimer();   
            });
        },
        cancelTimer(){
            let that = this;
            setTimeout(function(){
                that.alertText = '';
            }, 3000);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/feedback/_feedback.js